import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

const Slide = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background: white;
  height: ${props => props.height};
  @media (min-width: 36em) {
    height: 100vh;
  }
  img {
    object-fit: ${props => props.fit || 'cover'} !important;
    object-position: ${props => props.position || '50% 50%'} !important;
    width: ${props =>
      props.vertical === true ? 'auto !important' : '100% !important'};
    height: ${props =>
      props.vertical === true ? '100% !important' : '100% !important'};
    @media (min-width: ${props => props.theme.responsive.medium}) {
      height: ${props =>
        props.vertical === true ? '95% !important' : '100% !important'};
    }

    @media (min-width: ${props => props.theme.responsive.veryLarge}) {
      width: auto !important;
      height: 95% !important;
    }
  }
  &::before {
    content: '';
    background: ${props =>
      props.visible === true ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)'};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 3;
    transition: background-color 500ms linear;
  }
`

class SlideImage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: '100vh',
      dark: this.props.dark,
    }
  }
  componentDidMount() {
    this.setState({
      height: window.innerHeight + 'px',
    })
  }

  componentDidUpdate(){
    if (this.props.slideNumber === this.props.id) {
      var menu = document.getElementById('menu')
      var headerWrapper = document.getElementById('headerWrapper')
      if (this.state.dark) {
        menu.classList.remove('dark')
        headerWrapper.classList.remove('dark')
        menu.classList.add('light')
        headerWrapper.classList.add('light')
      } else {
        menu.classList.remove('light')
        headerWrapper.classList.remove('light')
        menu.classList.add('dark')
        headerWrapper.classList.add('dark')
      }
    }
  }

  render() {
    const projectImage = this.props.projectImage
    const visible = this.props.visible

    return (
      <Slide
        fluid={projectImage.photo.fluid}
        vertical={projectImage.vertical}
        visible={visible}
        height={this.state.height}
        imgStyle={{
          width: 'inherit',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translateX(-50%) translatey(-50%)',
          background: 'white',
        }}
      />
    )
  }
}

export default SlideImage
